import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { GameServerGateway } from 'app/student/game-section/services/gateways/game-server-gateway';

import { MinistryFeedbackModel, MinistrySurveyModel, MinistrySurveyRewardModel } from './ministry.model';

@Injectable({
  providedIn: 'root'
})
export class MinistryFeedbackService {
  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlService);
  private readonly gameServerGateway = inject(GameServerGateway);

  private readonly rewardSourceId = 'ministry-survey-student-2025';

  public getParentSurvey(): Observable<MinistrySurveyModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback', 'Parent');
    return this.httpClient.get<MinistrySurveyModel>(url);
  }

  public getTeacherSurvey(): Observable<MinistrySurveyModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback', 'Teacher');
    return this.httpClient.get<MinistrySurveyModel>(url);
  }

  public getStudentSurvey(): Observable<MinistrySurveyModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback', 'Student');
    return this.httpClient.get<MinistrySurveyModel>(url);
  }

  public getMinistrySurveyRewards(): Observable<MinistrySurveyRewardModel> {
    const url: string = this.urlService.buildGameServerApiUrl('rewards');
    return this.gameServerGateway.get<MinistrySurveyRewardModel>(url, { s: this.rewardSourceId });
  }

  public claimMinistrySurveyReward(): Observable<MinistrySurveyRewardModel> {
    const url: string = this.urlService.buildServerApiUrl('MinistryFeedback', 'Rewards', 'Claim');
    return this.httpClient.post<MinistrySurveyRewardModel>(url, undefined);
  }

  public submitFeedback(feedback: MinistryFeedbackModel): Observable<MinistryFeedbackModel> {
    const url = this.urlService.buildServerApiUrl('MinistryFeedback');
    return this.httpClient.post<MinistryFeedbackModel>(url, feedback);
  }
}
